import React from 'react';
import _ from 'lodash';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import ConvertFileBasicInfoComponent from './convert-file-basic-info.component';


export const ConvertFileComponent = ({
  selectedConvertFile,
  convertFile,
  fieldType,
  formatType,
  fieldConversions,
  handleInnerBasicFormChange,
  handleFormItemChange,
  deleteSelectedService,
  handleInnerFormChange,
  parsingRule,
  back,
  handleFormSubmit,showTable
}: any) => {

  const tabItems=[
    {
        id:1,
        title:'Convert File Information',
        component: <ConvertFileBasicInfoComponent
        parsingRule={parsingRule}
        deleteSelectedService={deleteSelectedService} 
        fieldConversions={fieldConversions}
        formatType={formatType}
        fieldType={fieldType}
        selectedConvertFile={selectedConvertFile}
        handleInnerBasicFormChange={handleInnerBasicFormChange} 
        handleInnerFormChange={handleInnerFormChange}
        convertFile={convertFile}
        handleFormItemChange={handleFormItemChange}
        showTable={showTable}
      />,
    isVisible:true,
    }
  ]
  return (
    <>
     
     <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
       <TabContainer tabItems={tabItems} />
    
       <div className='flex w-full justify-end items-end'>
         <button
               onClick={back}
               type='button'
               className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              >
               Back
              </button>
              <button
             className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
               onClick={handleFormSubmit}
             
               type="submit"
           >
             Save
           </button>
         </div>
        </div>
    </>
  );
};
export default ConvertFileComponent;
